import { render, staticRenderFns } from "./DataSelectForm.vue?vue&type=template&id=ff9594ae&"
import script from "./DataSelectForm.vue?vue&type=script&lang=js&"
export * from "./DataSelectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports